module.exports = __webpack_public_path__ + "static/media/6.cb103e61.webp";